<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">账号管理</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">账号管理</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="search-bar">
				<label>姓名
					<el-input size="small" placeholder="姓名" style="width:10%;" clearable v-model.trim="filter.name" @keyup.enter.native="handleFilter(0)"></el-input>
				</label>
				<label>用户名
					<el-input size="small" placeholder="用户名" style="width:10%;" clearable v-model.trim="filter.username" @keyup.enter.native="handleFilter(1)"></el-input>
				</label>
				<!-- <label>工号
					<el-input size="small" placeholder="工号" style="width:10%;" clearable v-model.trim="filter.jobnum" @keyup.enter.native="handleFilter(2)"></el-input>
				</label> -->
				<div style="display: inline-block;">角色
					<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.roleId" @change="handleFilter(3, $event)">
						<el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
					</el-select>
				</div>
				<div style="display: inline-block;">
					<!-- 所属机构
					<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.departmentId" @change="handleFilter(4, $event)">
						<el-option v-for="item in sysOrgList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
					</el-select> -->
					科室<el-select size="small" class="multiple-select" filterable clearable multiple collapse-tags v-model="filter.selectDepId" placeholder="请选择"
								@change="handleFilter(2, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
				</div>
				<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<div class="action-bar">
				<el-button type="primary" size="mini" round @click="showDlg">新增账号</el-button>

				<!-- <el-upload style="display:inline-block;" action="" :show-file-list="false" :before-upload="onUpload"> -->
				<el-button type="primary" size="mini" round @click="showDlg3">批量导入</el-button>
				<!-- </el-upload>		 -->				
				<!-- <el-popconfirm confirmButtonText='删除' title="确定批量删除吗？" @confirm="delItem">
					<el-button slot="reference" type="danger" size="mini" round plain>批量删除</el-button>
				</el-popconfirm> -->
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
				<el-table-column prop="name" label="姓名" show-overflow-tooltip ></el-table-column>
				<el-table-column prop="username" label="用户名" width="200"></el-table-column>
				<!-- <el-table-column prop="jobnum" label="工号"></el-table-column> -->
				<el-table-column prop="roleName" label="角色"></el-table-column>
				<el-table-column label="所属科室" show-overflow-tooltip>
					<template slot-scope="scope">
						<span v-if="scope.row.allDepartment==1">所有科室</span>
						<span v-else v-text="scope.row.depList?.map(item=>item.depName).join(', ')"></span>
					</template>
				</el-table-column>
				<el-table-column prop="reviser" label="更新人" width="200"></el-table-column>
				<el-table-column prop="updateTime" label="更新记录时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<!-- <el-tooltip content="查看" placement="top" :enterable="false"><router-link target='_blank' :to="{name: 'System/ScheduleTemplateView', query: {templateId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip> -->
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>

							<el-tooltip content="修改密码" placement="top" :enterable="false"><i class="el-icon-lock" @click="showDlg(scope.row, true)"></i></el-tooltip>

							<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog id="user-dialog" :title="dlg.form.id > 0 ? '修改账号' : '新增账号'" width="530px" center :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="dlg.form">

				<el-form-item label="姓名" prop="name">
					<el-input autocomplete="off" v-model="dlg.form.name"></el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="username">
					<el-input autocomplete="off" v-model="dlg.form.username"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="roleId">
					<el-select filterable v-model="dlg.form.roleId" placeholder="请选择" >
						<el-option v-for="item in roleList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="所属机构" prop="orgIds">
					<el-select filterable v-model="dlg.form.roleId" placeholder="请选择" >
						<el-option v-for="item in sysOrgList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
					</el-select>
				</el-form-item> -->

				<el-form-item :class="dlg.form.allDepartment==1?'erroritem':'depitem'" label="科室权限" prop="depIds">
					<el-radio-group v-model="dlg.form.allDepartment" @change="changeDeps($event)">
						<el-radio :label="1">所有科室</el-radio>
						<el-radio :label="0">部分科室</el-radio>
					</el-radio-group>
					<!-- <el-cascader ref="depCascader" v-if="dlg.depActive" filterable :props="deptProps" v-model="dlg.form.depIds"></el-cascader> -->
					<el-select
							v-if="visible"
							v-model="dlg.form.depIds"
							multiple
							filterable
							remote
							reserve-keyword
							placeholder="请输入关键词"
							:remote-method="remoteMethod"
							@change="$forceUpdate()"
							value-key="value"
							:loading="loading">
							<el-option
							v-for="item in options"
							:key="item.id"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>
				</el-form-item>
				
				<el-collapse>
					<el-collapse-item title="高级设置" name="1">
						<el-form-item label="电话" prop="phone">
							<el-input autocomplete="off" v-model="dlg.form.phone"></el-input>
						</el-form-item>
						<el-form-item label="hisId" prop="hisId">
							<el-input autocomplete="off" v-model="dlg.form.hisId"></el-input>
						</el-form-item>
					</el-collapse-item>
				</el-collapse>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="btnLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>

		<el-dialog custom-class="relative" title="修改密码" width="500px" center :visible.sync="dlg.active2" :close-on-click-modal="false">
			<el-form ref="form2" size="small" label-width="80px" :rules="dlg.rules" :model="dlg.form2">
				<el-form-item label="密码" prop="newPwd">
					<el-input type="password" placeholder="密码" autocomplete="off" v-model="dlg.form2.newPwd"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="repeat">
					<el-input type="password" placeholder="确认密码" autocomplete="off" v-model="dlg.form2.repeat"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" round :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" size="mini" round :loading="isLoading" @click="saveForm2">保存</el-button>
			</div>
		</el-dialog>
		<!-- 批量添加用户 -->
		<el-dialog id="user-dialog" title="批量添加用户" width="530px" center :visible.sync="dlg.active3" :close-on-click-modal="false">
			<template v-if="!uploadSuccess">
				<p class="setTips">操作说明：1.填写导入用户的信息。2.上传填好的导入<br/>模板文件。</p>
				<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="dlg.form3">
					<el-form-item  label="导入文件" prop="file">
						<!-- <el-upload style="display:inline-block;" action="http://hm4.healthydao.com:8172/user/excel/import" :show-file-list="true" :before-upload="onUpload" :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'">
							<el-button size="mini" round>上传文件</el-button>
						</el-upload> -->
						<el-upload
							class="upload-demo"
							:action="url"
							:accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
							:before-upload="onUpload"
							:limit="1"
							:on-preview="handlePreview"
							:on-exceed="handleExceed"
							:file-list="fileList">
							<el-button size="small" type="primary">上传文件</el-button>
						</el-upload>
					</el-form-item>
				</el-form>
				<!-- <el-button class="download" type="text" size="mini" @click="downloadFile">下载导入模版文件</el-button> -->
				<div class="download"><a class="noline" href="user.xlsx" target="_blank">下载导入模版文件</a></div>


				<div slot="footer" class="dialog-footer">
					<el-button type="primary" :loading="isLoading" @click="saveForm3">提 交</el-button>
				</div>
			</template>
			<template v-if="uploadSuccess">
				<div class="uploadSuccess">
					<img src="../../assets/images/uploadSuccess.png" alt="">
					<p>数据导入成功<span class="u1">{{uploadRes.okCount}}</span>条，失败<span class="u2">{{ uploadRes.errorCount}}</span>条</p>
				</div>
				<div slot="footer" class="dialog-footer">
						<el-button v-if="uploadRes.errorCount>0" size="small" type="primary" round @click="downloadError">下载失败数据</el-button>
						<el-button size="small" round @click="closeDlg">关 闭</el-button>
					</div>
			</template>
		</el-dialog>

		
  </div>
	
			
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';

export default {
	mixins: [mixin],
	data(){
		let validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.dlg.form2.newPwd) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};	
		let checkDepIds=(rule, value, callback) => {
			if(this.dlg.form.depIds.length==0&&this.dlg.form.allDepartment!=1){
				callback(new Error('请选择'));
			}else{
				callback();
			}
		};
		return {
			dlg: {
				active: false,
				// 密码管理
				active2: false,
				// 批量导入
				active3:false,
				rules: {
					name: {required: true, message: '请输入', trigger: 'blur'},
					username: {required: true, message: '请输入', trigger: 'blur'},
					roleId: {required: true, message: '请选择', trigger: 'change'},
					newPwd: {required: true, message: '请输入', trigger: 'blur'},
					repeat: {required: true, validator: validatePass, trigger: 'blur'},
					file:{required: true, message: '请上传', trigger: 'blur'},
					depIds:{required: true, message: '请选择', trigger: ['change','blur','select'],
					validator:checkDepIds}
				},
				form: {name: '',username: '', jobnum: '', roleId:'', depIds: [], orgIds: undefined,phone:'',hisId:null,allDepartment:null},
				form2: {newPwd: undefined, repeat: undefined},
				form3: {roleId: undefined, depIds: undefined,file:null,allDepartment:null},
				depActive: false,
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				username: '',
				roleId: undefined,
				departmentId: undefined,
				pageNumber: 1,
				pageSize: 10
			},
			isDeptLoaded: false,
			deptProps: undefined,
			deptList: [],
			roleList: [],
			sysOrgList: [],
			fileList:[],
			formData:null,
			uploadSuccess:false,
			uploadRes:{},
			errorList:[],
			url:'',
			loading:false,
			options:[],
			visible:false,//科室权限选择框
			isLoading:false,
			depFilter:{
				departmentState:'',
				departmentType:'',
				id:'',
				name:'',
				orgId:'',
				pageNumber:1,
				pageSize:9999
			},
			btnLoading:false
		}
	},
	async created() {
		this.loadList();
		let u=await api.getHospitalBaseUrl();
		this.url=u+'/user/excel/import';
		console.log(this.url,'---------上传文件url');
		// 科室下拉
		api.getListComboboxDep(this.depFilter).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		});

		// 角色下拉
		api.getRoleList({ pageSize: 99999}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.roleList = res.data;
			}
		});
		
		// 机构下拉
		this.loadSysOrgAll({dataState: 0});
	},
	
	methods: {
		remoteMethod(query) {
			if (query !== '') {
				this.depFilter.name=query;
				this.loading = true;
				setTimeout(() => {
					api.getListComboboxDep(this.depFilter).then(res=>{
						this.loading = false;
						if (res.code == 1000 && res.data) {
							this.options=res.data.map(item=>{
								return { value: item.id, label: item.name,...item };
							})
						}
					})
				}, 200);
			} else {
				this.options = [];
			}
		},
		changeDeps(e){
			if(e==1){
				// api.getOrgDept().then((res)=>{
				// 	if (res.code == 1000 && res.data) {
				// 		this.deptList = res.data.map(item => {
				// 			return { value: `${item.depId}`, label: `${item.depName}`,...item };
				// 		});
				// 	}
				// })
				// if(this.dlg.active3){
				// 	this.dlg.form3.depIds = this.deptList.map(item => { return item.label });
				// }else if(this.dlg.active){
				// 	this.dlg.form.depIds = this.deptList.map(item => { return item.label });
				// }
				this.dlg.form.allDepartment=1;
				this.dlg.form.depIds=[];
				this.visible=false;
			}else{
				this.dlg.form.allDepartment=0;

				if(this.dlg.active3){
					this.dlg.form3.depIds=null;
				}else if(this.dlg.active){
					this.dlg.form.depIds=null;
				}
				setTimeout(() => {
					this.visible=true
				}, 300);
			}
			this.$forceUpdate()
		},
		async loadList() {
			this.isLoading = true;
			let res = await api.getUserList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				// res.data.forEach((item)=>{
				// 	item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');deptProps
				// })
				this.list.data = res.data;
				// console.log(res.data,'--------ddd');
			}
			this.isLoading = false;
		},
		async loadSysOrgAll() {
			let res = await api.getSysOrgAll();
			this.sysOrgList = res.data;
		},
		showDlg(item, isPwd) {
			this.options=[];

			// this.deptProps = undefined;
			this.dlg.active = !isPwd;
			this.dlg.active2 = isPwd;
			if (item && item.id > 0) {
				this.$nextTick(async ()=>{
					if (isPwd) {
						this.dlg.form2.id = item.id;
						this.$refs['form2']?.resetFields();
					} else {
						// this.$refs['form']?.resetFields();
						let res = await api.getUser(item.id);
						if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
						this.dlg.form = res.data;
						this.options=this.dlg.form.depList.map(item=>{
								return { value: item.depId, label: item.depName,...item };
							})
						this.dlg.form.depIds = this.dlg.form.depList.map(item =>{return parseInt(item.depId)});
						this.visible=res.data.allDepartment==0?true:false;
					}
				});
			} else {
				this.dlg.form.id = 0;
				this.dlg.form2.id = 0;
				this.$nextTick(()=>{
					this.$refs['form']?.resetFields();
					this.$refs['form2']?.resetFields();
				});
			}
		},
		showDlg3(){
			this.options=[];
			this.fileList=[];

			this.dlg.active3 = true;
			this.dlg.form3={};
		},
		setValue(arr){
			this.nodes=arr;
			let cs=this.$refs['depCascader']; 
			let newArr= arr.map(item=>{
				return item.orgName+'/'+item.depName
			})
			cs.inputValue=newArr
		},
		closeDlg() {
			this.dlg.active = false;
			this.dlg.active2 = false;
			this.dlg.active3 = false;
			this.uploadSuccess=false;
			this.fileList=[];
		},
		extractNumbers(arr) {
			return arr.map(item => {
				if (!isNaN(item)) {
					return item;
				}else {
					let id=this.dlg.form.depList.find(ite=>{
						return ite.depName==item
					}).depId;
					return id;
				}
			});
		},
		async saveForm() {
			this.btnLoading=true;
			let res;
			this.$refs['form'].validate(async (valid,event)=>{
				console.log(valid,'=====d',this.dlg.form,event)
				// const postForm = JSON.parse(JSON.stringify(this.dlg.form));
				if(valid){

					if(this.dlg.form.allDepartment==0){
						this.dlg.form.depIds=this.extractNumbers(this.dlg.form.depIds);
					}
					const postForm = {
						id: this.dlg.form.id,
						name: this.dlg.form.name,
						roleId: this.dlg.form.roleId,
						username: this.dlg.form.username,
						jobnum: this.dlg.form.jobnum,
						depIds:this.dlg.form.depIds,
						phone:this.dlg.form.phone,
						hisId:this.dlg.form.hisId,
						allDepartment:this.dlg.form.allDepartment
					};
					console.log(postForm)
					if (postForm.depIds.length) {
						let arr=postForm.depIds.filter(item => item !== null);
						postForm.depIds = arr.join(',');
					}
					if (valid||this.dlg.form.allDepartment==1) {
						if (this.dlg.form.id > 0) {
							res = await api.editUser(postForm);
						} else {
							res = await api.addUser(postForm);
						}

						if (res.code != 1000) {
							this.$message.error(res.message);
							return;
						}
						this.loadList();
						this.$message({message: '保存成功',type: 'success'});
						this.closeDlg();
						this.dlg.form.allDepartment=null;
					}
				}

			})
			this.btnLoading=false;
		},
		// 修改密码
		saveForm2() {
			this.$refs['form2'].validate(async (valid)=>{
				if (valid) {
					this.isLoading = true;
					let res = await api.editUserPassword(this.dlg.form2);
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.$message.success('保存成功');
					this.closeDlg();
				}
			});			
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delUser({id: item.id});
			} else {
				// 批量删除
				if (this.multipleSelection.length == 0) {
					this.isLoading = false;
					return this.$message.warning('未选择任何数据');
				}
				res = await api.delUser({ids: this.multipleSelection.join(',')});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			if(key==2){
				if(this.filter.selectDepId){
					this.filter.depIds=this.filter.selectDepId.join(',')
				}
			}
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		async onUpload(file) {
			const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; // 检查文件类型
			if (!isXLSX) {
				this.$message.error('只能上传xlsx格式的文件');
			}
		
			let obj={
				...this.dlg.form3,
				file:file
			}
			let depid;
			
			if (this.dlg.form3.depIds) {
				if(this.dlg.form3.allDepartment==1){
					depid=this.deptList.map(item=>{
						return item.depId;
					})
				}else{
					depid = obj.depIds.join(',');
				}
			}
			// console.log(this.dlg.form3,'---',obj.depIds);
			let formData = new FormData();
			formData.append("file", file);
			// formData.append('depIds',depid);
			// formData.append('roleId',this.dlg.form3.roleId)
			this.formData=formData

			// const res = await api.importUser(this.dlg.form3);
			// console.log(res,'-------res');			
		},
		handleRemove(file, fileList) {
			console.log(file, fileList);
		},
		handlePreview(file) {
			console.log(file,'------------ff');
		},
		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${ file.name }？`);
		},
		// 下载模板
		downloadFile(){
			console.log();
			let url = api.downloadUserExcel();
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
		},
		// 下载失败数据
		downloadError(){
			console.log(this.uploadRes.errorList,'------this.uploadRes.errorList');
			let url = api.downloadUserErrorList({
				userErrorVos:JSON.stringify(this.uploadRes.errorList)
			});
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);
		},
		async saveForm3(){
			console.log(this.dlg.form3,'=============xxxxxxxxx',this.formData);
			this.isLoading=true
				// let formData = new FormData();
				// formData.append("file", this.dlg.form3file);
			let res = await api.userExcelInsert(this.formData);
			if(res.code==1000){
				this.uploadRes=res.data;
				this.uploadSuccess=true;
				this.loadList();
			}
			this.isLoading=false;
			this.dlg.form3.allDepartment=null;
		},
		
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

.search-bar{
		.multiple-select{
			margin-left: 10px;
			/deep/ .el-input{
				width: 250px;
				margin:0;
			}
		}
	}
#user-dialog{
	.setTips{
		text-align: center;
		line-height: 22px;
		color: #bcbcbc;
		margin-top: -18px;
	}
	.download{
		text-align: center;

		a{
		color: #699CE4;
			
		}
	}
	.uploadSuccess{
		text-align: center;
		img{
			width: 62px;
			height: 62px;
		}
		.u1{
			color: #699CE4;
		}
		.u2{
			color:#FF3636;
		}
		
	}
	::v-deep .el-cascader__tags{
		max-height: 300px;
		overflow: auto;
		width: 99%;
		// >input{
		// 	max-width: 280px;
		// 	overflow: hidden;
		// 	text-overflow: ellipsis;
		// }
	}

	::v-deep .el-cascader__tags::-webkit-scrollbar {
    width: 4px;
  }
  ::v-deep .el-dialog__body{
	padding-bottom: 0;
  }
  ::v-deep .el-cascader__tags::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    opacity: 0.2;
  }
  ::v-deep .el-cascader__tags::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
  }
  ::v-deep .el-select{
	.el-select__tags{
		max-height: 120px;
		overflow: auto;
	}
  }
  .erroritem{
	::v-deep .el-form-item__error{
		display: none !important;
	}
  }
}
</style>
